import React, { FC, useEffect } from 'react'
import Button from '../../../../../components/Atoms/Button/Button'
import useForm, { OnSubmitParams } from '../../../../../components/Core/Hooks/useForm/useForm'
import {
  FormStyle,
  FormHeader,
  FormTitle,
  FormFooter,
  FormFooterActionsLeft,
  FormFooterActionsRight,
} from '../../../../../components/Organisms/Form/Form.styles'
import utils from '../../../../../components/Organisms/Form/utils'
import config from './config'
import t from '../../../../../translations/main'
import { FormProps } from '../../../../Pages/Onboarding/types'

const InvestmentObjectivesForm: FC<FormProps> = props => {
  const submitForm = (data: OnSubmitParams) => {
    const { submit } = props
    if (submit) submit(data)
  }

  const {
    formData,
    emptyValidation,
    toggleShowByName,
    toggleShowByVisualName,
    handleInputChange,
    handleSubmit } =
    useForm(props.fetchedData, config, submitForm)

  useEffect(() => {
    const displayInvestmentDetails = Boolean(formData?.futuresTypeOfInvestment?.value) || Boolean(formData?.optionsTypeOfInvestment?.value)
    toggleShowByName('financials', displayInvestmentDetails)
    toggleShowByName('softCommodities', displayInvestmentDetails)
    toggleShowByName('energy', displayInvestmentDetails)
    toggleShowByName('preciousMetals', displayInvestmentDetails)
    toggleShowByName('baseMetals', displayInvestmentDetails)
    toggleShowByName('other', displayInvestmentDetails)
    toggleShowByVisualName('pleaseIndicate', displayInvestmentDetails ? 'true' : 'false')
  },[formData?.futuresTypeOfInvestment?.value, formData?.optionsTypeOfInvestment?.value])

  useEffect(() => {
    toggleShowByName('specifyOther', Boolean(formData?.other?.value))
  }, [formData?.other?.value])

  return (
    <FormStyle onSubmit={handleSubmit}>
      <FormHeader>
        <FormTitle>{t('onboarding.forms.IndividualAccount.InvestmentObjectivesForm.title')}</FormTitle>
      </FormHeader>
      {utils.sectionBuilder(config, formData, handleInputChange)}
      <FormFooter noOfButtons={2}>
        <FormFooterActionsLeft>
          {!props.disablePrev && (
            <Button label={t('onboarding.main.backButton')} version={2} disabled={props.disablePrev} />
          )}
        </FormFooterActionsLeft>
        <FormFooterActionsRight>
          <Button
            type='submit'
            label={props.isLastForm ? t('onboarding.main.saveAndSubmit') : t('onboarding.main.continueButton')}
            disabled={
              emptyValidation
              || (
                !formData?.futuresTypeOfInvestment?.value &&
                  !formData?.optionsTypeOfInvestment?.value &&
                  !formData?.foreignExchangeTypeOfInvestment?.value &&
                  !formData?.equitiesTypeOfInvestment?.value &&
                  !formData?.cfdTypeOfInvestment?.value
              )
              || (
                (Boolean(formData?.futuresTypeOfInvestment?.value) || Boolean(formData?.optionsTypeOfInvestment?.value))
                  && [formData.financials.value, formData.softCommodities.value, formData.energy.value, formData.preciousMetals.value, formData.baseMetals.value, formData.other.value].every(value => !value)
              )
              || (
                formData.other.value && formData.specifyOther.value === ''
              )
            }
          />
        </FormFooterActionsRight>
      </FormFooter>
    </FormStyle>
  )
}

export default InvestmentObjectivesForm
